package or.garden.manager.features.irrigation.components

import androidx.compose.runtime.Composable
import or.garden.manager.domain.model.IrrigationResponse
import org.jetbrains.compose.web.dom.*

@Composable
fun WebIrrigationCard(item: IrrigationResponse, onWatered: () -> Unit, onDelete: () -> Unit) {
    Div({
        val cardClasses = mutableListOf(
            "bg-white", "rounded-3xl", "p-8", "shadow-sm", "border", "relative", "hover:shadow-md", "transition-shadow"
        )
        if (item.urgent) cardClasses.add("border-red-400") else cardClasses.add("border-gray-100")
        classes(cardClasses)
    }) {
        Div({ classes("flex", "justify-between", "items-start", "mb-6") }) {
            Div({
                classes(
                    "w-14", "h-14", if (item.urgent) "bg-red-50" else "bg-blue-50", "rounded-2xl", "flex", "items-center", "justify-center"
                )
            }) {
                I({
                    classes(
                        "fas", "fa-tint", if (item.urgent) "text-red-500" else "text-blue-500", "text-2xl"
                    )
                })
            }

            Div({ classes("flex", "items-center", "gap-2") }) {
                if (item.urgent) {
                    Span({
                        classes(
                            "bg-red-500", "text-white", "text-xs", "font-black", "px-3", "py-1", "rounded-full", "uppercase", "tracking-wider"
                        )
                    }) { Text("HITNO") }
                }

                Button(attrs = {
                    classes("text-gray-400", "hover:text-red-500", "transition-colors", "p-2")
                    onClick { onDelete() }
                }) {
                    I({ classes("fas", "fa-trash-alt") })
                }
            }
        }

        H2({ classes("text-2xl", "font-bold", "text-[#1F2937]") }) { Text(item.bed.name) }

        Div({ classes("space-y-1", "mt-3") }) {
            Div({ classes("flex", "items-center", "gap-2", "text-gray-600") }) {
                I({ classes("far", "fa-calendar-alt", "text-xs") })
                Span { Text(item.humanNextDate) }
            }
            Div({ classes("flex", "items-center", "gap-2", "text-gray-500", "text-sm") }) {
                I({ classes("fas", "fa-redo", "text-xs") })
                val translatedFrequency = when (item.frequency.lowercase()) {
                    "daily" -> "Svaki dan"
                    "every_2_days" -> "Svaka 2 dana"
                    "every_3_days" -> "Svaka 3 dana"
                    "weekly" -> "Sedmično"
                    "biweekly" -> "Svake 2 sedmice"
                    "monthly" -> "Mjesečno"
                    else -> item.frequency
                }
                Span { Text(translatedFrequency) }
            }
        }

        Button(attrs = {
            classes(
                "w-full", "mt-8", "bg-blue-600", "hover:bg-blue-700", "text-white", "py-3", "rounded-xl", "font-bold", "flex", "items-center", "justify-center", "gap-2", "transition-all"
            )
            onClick { onWatered() }
        }) {
            I({ classes("fas", "fa-check") })
            Text("Označi kao zaliveno")
        }
    }
}
